<template>
  <div>
    <div class="container">
      <!--设计稿高度为500px，这里底层页面的高度没那么高，会溢出-->
      <el-table empty-text="" class="" :data="loanListData" @row-click="toLoanDetail">
    
        <el-table-column type='index' label="#" width="80px;">

          <template slot-scope="scope">
            <span style="padding:18px;">
            {{scope.$index + 1}}</span>
          </template>

        </el-table-column>
        <el-table-column prop="frontApplyDate" label="loan apply date"></el-table-column>

        <el-table-column class-name="front-apply-money" prop="frontApplyMoney" :formatter="formatMoney" label="loan amount"></el-table-column>
        <!--<el-table-column prop="bankAccountInfo" label="loan bank" width="210"></el-table-column>-->
        <el-table-column prop="frontApplyStatus" label="status"></el-table-column>
        <el-table-column prop="frontApplyNote" label="note"></el-table-column>
        <!--
        <el-table-column label="Action" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.isEditable === '0'">
              <el-button size="mini" @click.stop="toLoanEdit(scope.row)">
                {{loanAction.editText}}
              </el-button>
              <el-button size="mini" @click.stop="toLoanDelete(scope.row.frontApplyId, scope.row.itemApplyId)">
                {{loanAction.deleteText}}
              </el-button>
            </div>
             <div v-else-if="scope.row.isEditable === '2'">
              <el-button size="mini" @click.stop="toLoanEdit(scope.row)">
                {{loanAction.editText}}
              </el-button>
              <button class="disabled_btn">{{loanAction.deleteText}}</button>
            </div>
            <div v-else>
              <button class="disabled_btn">{{loanAction.editText}}</button>
              <button class="disabled_btn">{{loanAction.deleteText}}</button>
            </div>
          </template>
        </el-table-column>
        -->
      </el-table>

      <el-pagination class="pament-list-pagination" :small="isSmall"
                     layout="prev, pager, next" :page-count="pageCount"
                     :page-size="10" style="text-align: center;" :currentPage.sync="pageCurrent"
                     @current-change="getPage" v-show="pageCount > 1"></el-pagination>
    </div>
    <confirm-modal :show="isDeleteLoanItemFrontApply" content="Is it sure to delete the loan？" @confirm-click="deleteLoanItem"
                   @cancel-click="isDeleteLoanItemFrontApply = false"></confirm-modal>
  </div>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import * as types from '../../vuex/types'
  import _ from 'lodash'
  import confirmModal from '../common/Confirm.vue'
  import api from '../../vuex/api/index'
  export default {
    data () {
      return {
        isSmall: true,
        isDeleteLoanItemFrontApply: false,
        frontApplyId: '',
        itemApplyId: '',
        loanAction: {
          editText: 'edit',
          deleteText: 'delete'
        }
      }
    },
    components: {
      confirmModal
    },
    computed: {
      ...mapGetters({
        activeName: types.BROKER_ACTIVE_NAME,
        userInfo: types.GET_USER,
        pageCurrent: types.BROKER_PAGE_CURRENT,
        frontApplyState: types.BROKER_FRONT_APPLY_STATE,
        loanListData: types.BROKER_LOAN_LIST_DATA,
        pageCount: types.BROKER_PAGE_COUNT
      })
    },
    methods: {
      ...mapMutations({
        setFrontApplyState: types.SET_BROKER_FRONT_APPLY_STATE,
        setActiveName: types.SET_BROKER_ACTIVE_NAME,
        setFrontItemApplyState: types.SET_FRONT_ITEM_STATE_FRONT
      }),
      ...mapActions({
        getBrokerLoanListData: types.GET_BROKER_LOAN_LIST_DATA,
        getPageCurrent: types.GET_BROKER_PAGE_CURRENT,
        deleteLoanItemFrontApply: types.DELETE_BROKER_LOAN_ITEM_FRONT_APPLY
      }),
      formatMoney (obj) {
        const num = Number(obj.frontApplyMoney)
        let fmNum = !_.isNaN(num) ? (`${num.toFixed(0)}`).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,') : ''
        fmNum = `$${fmNum} (click to view detail)`
        return fmNum
      },
      toLoanDetail (row, event, column) {
        const target = event.target
        if (target.className !== 'disabled_btn') {
          this.setActiveName('2')
          this.setFrontItemApplyState(row.frontApplyState)
          this.$router.push({path: `/brokerCenter/applicationDetail/${row.frontApplyId}`})
        }
      },
      toLoanEdit (row) {
        const query = {
          applyLoanId: row.frontApplyId,
          isEdit: true
        }
        switch (row.frontApplyState) {
          case 'f1':
            this.$router.push({
              path: `/applyLoan/${row.frontApplyProductId}/step2`,
              query
            })
            break
          case 'f2':
            this.$router.push({
              path: `/applyLoan/${row.frontApplyProductId}/step3`,
              query: Object.assign(query, {
                selectedBankcardId: row.bankAccountId
              })
            })
            break
          case 'f3':
            this.$router.push({
              path: `/applyLoan/${row.frontApplyProductId}/step4`,
              query: Object.assign(query, {
                selectedBankcardId: row.bankAccountId
              })
            })
            break
          case 'f4':
            this.$router.push({
              path: `/applyLoan/${row.frontApplyProductId}/step4`,
              query: Object.assign(query, {
                selectedBankcardId: row.bankAccountId
              })
            })
            break
          default:
            this.$router.push({
              path: `/applyLoan/${row.frontApplyProductId}/step2`,
              query
            })
            break
        }
      },
      toLoanDelete (frontApplyId, itemApplyId) {
        this.frontApplyId = frontApplyId
        this.itemApplyId = itemApplyId
        this.isDeleteLoanItemFrontApply = true
      },
      deleteLoanItem () {
        this.deleteLoanItemFrontApply({
          token: this.userInfo.token,
          frontApplyId: this.frontApplyId,
          itemApplyId: this.itemApplyId
        }).then(() => {
          this.isDeleteLoanItemFrontApply = false
          this.getBrokerLoanListData({
            router: this.$router,
            frontApplyState: this.$route.query.frontApplyState,
            pageCurrent: this.pageCurrent,
            token: this.userInfo.token
          })
        })
      },
      getPage (currentPage) {
        this.getPageCurrent({pageCurrent: currentPage})
        this.$router.push({
          path: '/brokerCenter/myApplication/applicationList',
          query: {
            frontApplyState: this.frontApplyState,
            pageCurrent: this.pageCurrent
          }
        })
      }
    },
    created () {
      this.getBrokerLoanListData({
        token: this.userInfo.token,
        frontApplyState: 0,
        pageCurrent: this.pageCurrent
      })

      this.setActiveName('0')
      

    },
    watch: {
      $route () {
        if (_.isEmpty(this.$route.query)) {
          this.setActiveName('2')
          this.setFrontApplyState(2)
        } else if (this.$route.query.frontApplyState !== this.frontApplyState) {
          this.setFrontApplyState(this.$route.query.frontApplyState)
          this.getPageCurrent({pageCurrent: 1})
        }
        this.getBrokerLoanListData({
          token: this.userInfo.token,
          frontApplyState: this.frontApplyState,
          pageCurrent: this.pageCurrent
        })
      }
    }
  }
</script>
<style lang="scss">
  .front-apply-money {
    color: #35c4f9;
  }

  .loan-table {
    .el-tabs__active-bar {
      width: 0;
    }

    .el-button--mini {
      width: 44px;
      height: 22px;
      color: #fff;
      font-family: 'FZLanTingHei-DB-GBK';
      background: #35c4f9;
      border: none;
    }

    .el-button:focus,
    .el-button:hover {
      color: #fff;
    }

    .el-button.is-disabled,
    .el-button.is-disabled:focus,
    .el-button.is-disabled:hover {
      color: #fff;
      background-color: #99a3a7;
    }

    .el-pager li.number {
      line-height: 19px;
      color: #a1a9ac;
      &.active {
        color: #21c2f9;
        border-color: transparent;
        background-color: transparent;
      }
    }

    .el-pagination {
      padding: 12px 0;
      button.disabled {
        color: #99a2a7;
      }
    }

    .el-table__body-wrapper {

      tr {
        position: relative;
        &:not(:first-child):after {
          content: '';
          position: absolute;
          left: 13px;
          height: 1px;
          background-color: #F6F6F6;
        }
      }
    }

    .table-body {
      box-sizing: border-box;
      border: none;

      &:before {
        display: none;
      }

      &:after {
        display: none;
      }

      td {
        /*border-bottom: 1px solid #F6F6F6;*/
        border-bottom: none;
      }

      th.is-leaf {
        border-bottom: none;
        overflow: hidden;
        height: 27px;
        background: none;
      }

      .cell {
        text-align: center;
        line-height: 59px;
        font-size: 14px;
        font-weight: bold;
      }

      th .cell {
        font-size: 12px;
        color: #cdd8dc;
        line-height: 27px;
        background: none;
      }

      .item_index {
        position: relative;
        display: inline-block;
        border-radius: 2px;
        width: 25px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: $white;
        font-size: 12px;
        font-weight: normal;
        background: #cdd8dc;
      }
    }
  }

  .disabled_btn{
    display:inline-block;
    width:44px;
    height:22px;
    margin:0 5px;
    background: #99A3A7;
    font-size: 12px;
    border:none;
    border-radius: 3px;
    color:#fff;
    cursor: not-allowed;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// ApplicationList.vue?534759dc